export default "__VITE_ASSET__Bya9pxTb__"